import { withTranslation } from 'react-i18next';

// Import helpers
import { checkAppType } from 'helpers';
import { sendHeaderMenuEvent } from 'helpers/tracking';

// Import components
import { Nav } from 'components/elements';

const NavLinks = ({ t, links }) => {
	const { appName } = checkAppType();

	return (
		<Nav.List dropdown>
			{links.map(({ id, path, name, state, itemModifiers, navLinkModifiers }) => {
				const navItem = name === 'home' ? `home_${appName}` : name;
				return (
					<Nav.Item key={id} modifiers={itemModifiers}>
						<Nav.NavLink
							to={{ pathname: path, state }}
							activeClassName="active-nav"
							modifiers={navLinkModifiers}
							onClick={sendHeaderMenuEvent.bind(null, {
								url: path,
								text: t(`common_header_nav_${navItem}`)
							})}
						>
							{t(`common_header_nav_${navItem}`)}
						</Nav.NavLink>
					</Nav.Item>
				);
			})}
		</Nav.List>
	);
};

export default withTranslation()(NavLinks);
